module.exports = __webpack_public_path__ + "static/media/Screen Shot 2020-08-19 at 2_1597702911073.a576c62b.16";